import { Action, Dispatch } from 'redux'
import { updatePublishFirstStockAction } from 'reducks/store/actions'

const updatePublishFirstStock = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(updatePublishFirstStockAction())
  }
}

export default updatePublishFirstStock
